module.exports = __webpack_public_path__ + "static/img/img_empty_search@2x.e0ea8ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_empty_search@2x.png
// module id = 6BjF
// module chunks = 1